import React from 'react';
import { SYSTEM_TIMEZONE_IANA } from './local';


export const TimezoneContext = React.createContext<string>(SYSTEM_TIMEZONE_IANA);
export const TimezoneSetContext = React.createContext<(timezone: string) => void>(() => void 0);
